import { useSelector } from "react-redux";
import { RootState } from "../../../state/store";
import axios from "axios";
import { useEffect, useState } from "react";

type KpisModuleProps = {
    enlargedCard: any,
    setEnlargedCard: (obj: any) => void,
    baseUrl: string,
    kpis: any,
    kpisLoading: boolean,
    filter: string,
    currentUser: any,
}
export default function KpisModule({ enlargedCard, setEnlargedCard, baseUrl, kpis, kpisLoading, filter, currentUser }: KpisModuleProps) {
    
    
    return (
        <section className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">

            {kpis.map((kpi: any) => (
                <div
                    key={kpi.label}
                    className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm flex flex-col items-center text-center justify-between cursor-pointer hover:shadow-md"
                    onClick={() => setEnlargedCard(kpi)}
                >
                    <p className="text-xs uppercase tracking-wide text-slate-400 mb-1">{kpi.label}</p>
                    {kpisLoading ? (
                        <div className="flex items-center justify-center h-64">
                            <div className="flex flex-col items-center">
                                <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                                <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                            </div>
                        </div>
                    ) : (
                    <div>
                        
                        <p className="text-2xl font-semibold mb-1">{kpi.value}</p>
                        {kpi.label !== "Aktive agenter" && kpi.label !== "Aktive kunder" && (
                            <span className={`inline-flex items-center text-xs font-medium ${kpi.trend.includes("-") ? 'text-red-600 bg-red-50' : 'text-emerald-600 bg-emerald-50'} rounded-full px-2 py-1 self-start`}>
                                {kpi.trend.includes("-") ? "↓" : "↑"} {kpi.trend} siste {filter}
                            </span>
                        )}
                    </div>
                    )
                    }
                </div>

            ))}
        </section>
    )
}